import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AppSettingsProvider } from './services/AppSettingsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import NewReportPage from './pages/NewReportPage';
import HistoryPage from './pages/HistoryPage';
import ReportDetailPage from './pages/ReportDetailPage';
import AccountingPage from './pages/AccountingPage';
import HelpPage from './pages/HelpPage';
import AccountingHelpPage from './pages/AccountingHelpPage';

export default function App() {
  return (
    <AuthProvider>
      <AppSettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout><DashboardPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-report"
            element={
              <ProtectedRoute>
                <Layout><NewReportPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <Layout><HistoryPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/history/:reportId"
            element={
              <ProtectedRoute>
                <Layout><ReportDetailPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <ProtectedRoute>
                <Layout><AccountingPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Layout><HelpPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/help/accounting"
            element={
              <ProtectedRoute>
                <Layout><AccountingHelpPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      </AppSettingsProvider>
    </AuthProvider>
  );
}
